
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import TableEnableFlag from "@/components/scope/table-enable-flag.vue";
import { formDownload } from "@common/src/utils/tools";
import { addCurrencyUnit } from "@common/src/utils/tools";
import { InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
const warehouse = namespace("warehouse");
const common_warehouse = namespace("common_warehouse");
const parts = namespace("parts");
const base = namespace("base");
const inventory = namespace("inventory");
const partsCategory = namespace("parts-category");
const management = namespace("management");
const setting = namespace("setting");
const common_inventory = namespace("common_inventory");
@InjectFunction("emptyToLine", "splitThousands", "permit", "permitApp", "appCode")
@Component({
  components: { TableEnableFlag }
})
@Table("loadListData")
export default class Parts extends Vue {
  @common_inventory.State taxIncludeList;
  @inventory.Action getPartsInventoryList;
  @parts.Action updateStatus;
  @partsCategory.Action getCategoryList;
  @management.Action getStoreList;
  @base.Action getDictionaryList;
  @parts.Action getPartsBrandList;
  @warehouse.Action getWarehouseList;
  @common_warehouse.Action queryWarehouseShelfTree;
  @setting.State fifoStatus;
  @setting.State productionBatchNoStatus;
  @common_inventory.Action opQueryStoreMode;
  searchForm = {
    storeCode: "",
    partsName: "",
    partsCustomizeCode: "",
    warehouseCode: "",
    partsCategoryCode: "",
    brandCode: "",
    findInvEmpty: "0",
    alertFlag: "",
    partsCodeArray: [],
    shelfCode: "", // 库位Code
    showWarehouse: "1",
    showShelf: "1",
    showInboundBatchNo: "1",
    showProductionBatchNo: "1",
    inboundBatchNo: "",
    productionBatchNo: ""
  };
  hideCost: boolean = true;
  addCurrencyUnit = addCurrencyUnit;
  sortForm: {};
  partsList: any[] = [];
  defaultStoreCode = "";
  get searchList() {
    return [
      ...(this.appCode === "speedbiz-operation"
        ? [
            {
              label: t("v210831.store-name"),
              type: "select-search",
              value: this.defaultStoreCode,
              prop: "storeCode",
              placeholder: t("v210801.please-enter-keyword"),
              selectList: this.storeList,
              searchFun: this.searchStore,
              changeMethod: this.handleStoreChange,
              clearable: false,
              noKeepOld: true,
              required: true
            }
          ]
        : []),
      {
        label: t("v216_g.parts_custom_code"),
        type: "input",
        value: "",
        prop: "partsCustomizeCode"
      },
      {
        label: t("parts.name"),
        type: "input",
        value: "",
        prop: "partsName"
      },
      {
        label: t("parts.code"),
        type: "input",
        value: "",
        prop: "partsNumber"
      },
      {
        label: t("parts.category"),
        type: "cascader",
        prop: "partsCategoryCode",
        value: "",
        options: this.categoryList,
        props: {
          label: "categoryName",
          value: "categoryCode"
        }
      },
      ...(this.appCode === "speedbiz"
        ? [
            {
              label: "setting.brand",
              type: "select",
              value: "",
              prop: "brandCode",
              selectList: this.brandList
            }
          ]
        : []),

      ...(this.appCode === "speedbiz"
        ? [
            ...(this.searchForm.showWarehouse === "1" || this.searchForm.showShelf === "1"
              ? [
                  {
                    label: "warehouse.warehouse",
                    type: "select",
                    value: "",
                    selectList: this.warehouseList,
                    clearMethod: this.handleSearchWarehouseClear,
                    changeMethod: this.handleSearchWarehouseChange,
                    prop: "warehouseCode"
                  }
                ]
              : []),
            ...(this.searchForm.showShelf === "1"
              ? [
                  {
                    label: t("v210.location"),
                    type: "select",
                    value: "",
                    selectList: this.shelfList,
                    prop: "shelfCode",
                    disabled: this.shelfSelectDiasabled,
                    noKeepOld: true
                  }
                ]
              : [])
          ]
        : []),
      ...(this.searchFifoShow
        ? [
            {
              label: t("v216_g.inbound_batch_no"),
              type: "input",
              value: "",
              prop: "inboundBatchNo"
            }
          ]
        : []),
      {
        label: t("speedbiz-v217_0.Tax-included"),
        type: "select",
        value: "",
        selectList: this.taxIncludeList,
        prop: "taxIncluded"
      },
      ...(this.searchProductionNoShow
        ? [
            {
              label: t("v216_g.production_batch_no"),
              type: "input",
              value: "",
              prop: "productionBatchNo"
            }
          ]
        : [])
    ];
  }
  categoryList: any = [];
  warehouseList: any = [];

  brandList: any = [];
  get isShowAlert() {
    return this.$route.query.showAlert === "1";
  }
  get urlPartsCodeArr() {
    if (this.$route.query.partCodeArr) {
      return (this.$route.query.partCodeArr as string).split(",");
    } else {
      return undefined;
    }
  }
  created() {
    this.init();
  }
  handleExportData() {
    if (!this.onlyShowZeroStock) {
      this.searchForm.findInvEmpty = "1";
    } else {
      this.searchForm.findInvEmpty = "0";
    }
    if (this.onlyShowStockAlert) {
      this.searchForm.alertFlag = "1";
    } else {
      this.searchForm.alertFlag = "";
    }
    if (this.appCode === "speedbiz") {
      formDownload(`${window.API_URL}/inventory/v2/qtyExport`, this.searchForm);
    } else {
      formDownload(`${window.API_URL}/opInventory/v2/qtyExport`, this.searchForm);
    }
  }
  warehouseShelfMap: any = {};
  async init() {
    if (this.isShowAlert) {
      this.searchForm.alertFlag = "1";
      this.onlyShowStockAlert = true;
    }
    if (this.urlPartsCodeArr) {
      this.searchForm.partsCodeArray = this.urlPartsCodeArr;
    }
    if (this.appCode === "speedbiz") {
      this.getBrandList();
      this.queryWarehouseShelfTree({
        pageNum: 1,
        pageSize: 100
      }).then(data => {
        let list = this.$safeValue(data, "data.warehouseList", []);
        let warehouseList = [];
        list.forEach(item => {
          warehouseList.push({
            label: item.warehouseName,
            value: item.warehouseCode
          });
          if (!this.warehouseShelfMap[item.warehouseCode]) {
            this.warehouseShelfMap[item.warehouseCode] = item.shelfList;
          }
        });
        this.warehouseList = warehouseList;
      });
    }
    if (this.appCode === "speedbiz") {
      this.searchForm.showInboundBatchNo = this.fifoStatus === "1" ? "1" : "0";
      this.searchForm.showProductionBatchNo = this.productionBatchNoStatus === "1" ? "1" : "0";
      this.loadListData();
    } else {
      this.searchStore("MCS MOTORSPORTS SDN BHD").then(data => {
        if (data?.[0]) {
          const storeCode = data?.[0]?.value || "";
          this.searchForm.storeCode = storeCode;
          this.defaultStoreCode = storeCode;
          this.loadListData();
          this.handleStoreChange(storeCode);
        }
      });
    }

    const data = await this.getCategoryList();
    this.categoryList = this.addLeafFlag(this.$safeValue(data, "data", []));
  }
  handleStoreChange(val) {
    this.defaultStoreCode = val;
    this.opQueryStoreMode({ storeCode: val }).then(data => {
      this.searchForm.showInboundBatchNo = data.data?.fifoStatus === "1" ? "1" : "0";
      this.searchForm.showProductionBatchNo = data.data?.productionBatchNoStatus === "1" ? "1" : "0";
      this.selectedStoreFifoStatus = data.data?.fifoStatus === "1" ? "1" : "0";
      this.selectedStoreProductionBatchNoStatus = data.data?.productionBatchNoStatus === "1" ? "1" : "0";
    });
  }
  handleLinkPartsDetail(row) {
    if (this.appCode === "speedbiz") {
      let { href } = this.$router.resolve({
        path: `/setting/parts-edit/${row.partsCode}`
      });
      window.open(href, "_blank");
    }
  }
  getBrandList() {
    this.getPartsBrandList().then(data => {
      this.brandList = this.$safeValue(data, "data.list", []).map(item => ({
        label: item.brandName,
        value: item.brandCode
      }));
    });
  }
  inventoryQty: any = "";
  inventoryAmount: any = "";
  @Table.LoadDataMethod()
  loadListData() {
    if (!this.onlyShowZeroStock) {
      this.searchForm.findInvEmpty = "1";
    } else {
      this.searchForm.findInvEmpty = "0";
    }
    if (this.onlyShowStockAlert) {
      this.searchForm.alertFlag = "1";
    } else {
      this.searchForm.alertFlag = "";
    }
    if (!this.searchFifoShow) {
      this.searchForm.inboundBatchNo = "";
    }
    if (!this.searchProductionNoShow) {
      this.searchForm.productionBatchNo = "";
    }
    return this.getPartsInventoryList({
      // status: "9",
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      partsName: this.searchForm.partsName
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []);
      this.inventoryQty = data.data.inventoryQty;
      this.inventoryAmount = data.data.inventoryAmount;
      return data;
    });
  }
  addLeafFlag(list) {
    if (!list) return;
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  handleSearch(data, type) {
    if (type === "reset") {
      this.shelfSelectDiasabled = true;
    }
    this.searchForm.partsCodeArray = [];
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "partsCategoryCode") {
          this.searchForm[item.prop] = item.value[item.value.length - 1] || "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    if (this.appCode === "speedbiz-operation" && !this.searchForm.storeCode) {
      this.$message.error(t("v213.you-must-specify-a-store"));
      return false;
    }
    this.loadListData();
  }
  onlyShowStockAlert: boolean = false;
  onlyShowZeroStock: boolean = false;
  storeList: any = [];
  searchStore(val = "") {
    return this.getStoreList({
      pageNum: 1,
      pageSize: 10,
      storeName: val
    }).then(data => {
      this.storeList = data.data.list
        ? data.data.list.map(item => {
            item.label = item.storeName;
            item.value = item.storeCode;
            return item;
          })
        : [];
      return this.storeList;
    });
  }
  handleBtnFilterChagne() {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  shelfList: any = [];
  shelfSelectDiasabled: boolean = true;
  handleSearchWarehouseChange(val) {
    this.shelfSelectDiasabled = false;
    this.searchForm.shelfCode = "";
    this.shelfList = (this.warehouseShelfMap[val] || []).map(item => {
      item.label = item.shelfDesc;
      item.value = item.shelfCode;
      return item;
    });
  }
  handleSearchWarehouseClear() {
    this.shelfSelectDiasabled = true;
  }
  selectedStoreFifoStatus = "0";
  selectedStoreProductionBatchNoStatus = "0";
  get storeFifoStatus() {
    return this.selectedStoreFifoStatus === "1" || this.fifoStatus === "1";
  }
  get storeProductionBatchNoStatus() {
    return this.selectedStoreProductionBatchNoStatus === "1" || this.productionBatchNoStatus === "1";
  }
  get searchFifoShow() {
    return this.storeFifoStatus && this.searchForm.showInboundBatchNo === "1";
  }
  get searchProductionNoShow() {
    return this.storeProductionBatchNoStatus && this.searchForm.showProductionBatchNo === "1";
  }
}
